<template>
  <div
    class="c-outreach-contact-social-feed"
    data-testid="outreach-contact-social-feed"
  >
    <template v-if="props.twitterUsername">
      <OutreachContactTweets
        v-if="socialIntegrationId"
        :scroll-target="props.scrollTarget"
        :social-integration-id="socialIntegrationId"
        :twitter-username="props.twitterUsername"
      />
      <div
        v-else
        class="c-outreach-contact-social-feed__center"
      >
        <OutreachContactConnectTwitter
          @set-social-integration-id="socialIntegrationId = $event"
        />
      </div>
    </template>
    <div
      v-else
      class="c-outreach-contact-social-feed__center"
    >
      <div>
        <QIcon
          name="ion-alert"
          size="1.5rem"
        />
      </div>
      <div>{{ $t("outreach_contact_social_feed.no_username") }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { type Nullable } from "shared/types";

import OutreachContactConnectTwitter from "./OutreachContactConnectTwitter.vue";
import OutreachContactTweets from "./OutreachContactTweets.vue";

const props = defineProps<{
  scrollTarget?: string;
  twitterUsername: Nullable<string>;
}>();

const socialIntegrationId = ref<Nullable<string>>(null);
</script>

<style scoped lang="scss">
.c-outreach-contact-social-feed {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;

  &__center {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--s-spacing-md);

    .q-icon {
      color: var(--s-color-red-4);
    }
  }
}
</style>
